import React from 'react';
import { Link } from 'react-router-dom';

const OpenJobs = () => {
  return (
    <>
      <section id='open-positions' class='open-jobs ptb-60'>
        <div class='container'>
          <div class='row align-items-center justify-content-between'>
            <div class='col-lg-4 col-md-12'>
              <div class='section-heading'>
                <h4 class='h5 text-primary'>Our Jobs</h4>
                <h2>Current Available Positions at Senertech</h2>
              </div>
            </div>
            <div class='col-lg-7 col-md-12'>
              <p className='text-muted text-bold fs-5'>
                Join our team and be part of a dynamic, growth-driven environment where innovation and creativity thrive. We believe in empowering our people, nurturing talent, and creating opportunities to build rewarding careers. Explore our open positions and take the next step towards shaping your future with us.{' '}
              </p>
            </div>
          </div>
          <div className='row justify-content-center'>
            <div className='col-lg-12 col-md-12'>
              <div className='text-decoration-none mt-4 mt-xl-0 mt-lg-0 single-open-job p-5 bg-dark text-white d-block rounded-custom'>
                <div className='d-flex justify-content-between align-items-center'>
                  <span className='job-time h-6 mb-2'>
                    <i className='far fa-briefcase me-2'></i>
                    <strong>No Open Positions at the Moment</strong>
                  </span>
                  {/* <span className='badge px-3 py-2 bg-custom-light rounded-pill small'>
          Careers
        </span> */}
                </div>
                <h3 className='h5 mt-3'>
                  Thank you for your interest in joining <strong>Senertech</strong>.
                </h3>
                <p className='text-muted mt-3'>
                  We don’t have any active openings right now, but we’re always looking for
                  talented and passionate people to be part of our journey. Please check back
                  soon for updates.
                </p>
                <div className='mt-4'>
                  Want to stay connected? Share your resume with us at <strong>hello@senertech.in</strong> and we’ll reach out when a suitable role opens up.
                </div>
              </div>
            </div>
          </div>

          {/* <div class='row justify-content-center'>
            <div class='col-lg-12 col-md-12'>
              <Link
                to='/career-single'
                class='text-decoration-none mt-4 mt-xl-0 mt-lg-0 single-open-job p-5 bg-dark text-white d-block rounded-custom'
              >
                <div class='d-flex justify-content-between align-items-center'>
                  <span class='job-time h-6 mb-2'>
                    <i class='far fa-briefcase me-2'></i>{' '}
                    <strong>Remote - Full Time</strong>
                  </span>
                  <span class='badge px-3 py-2 bg-custom-light rounded-pill small'>
                    Developer
                  </span>
                </div>
                <h3 class='h5'>Jr Frontend Developer</h3>
                <ul class='job-info-list list-inline list-unstyled text-muted'>
                  <li class='list-inline-item'>
                    <span class='far fa-house-building me-1'></span> Google
                  </li>
                  <li class='list-inline-item'>
                    <span class='far fa-map-marker-alt me-1'></span> London, UK
                  </li>
                  <li class='list-inline-item'>
                    <span class='far fa-wallet me-1'></span> $35k - $45k
                  </li>
                </ul>
                <div class='btn btn-outline-light btn-sm d-inline-block mt-4'>
                  Apply Now
                </div>
              </Link>
            </div>
            {/* <div class='col-lg-6 col-md-12'>
              <Link
                to='/career-single'
                class='text-decoration-none mt-4 mt-xl-0 mt-lg-0 single-open-job p-5 bg-dark text-white d-block rounded-custom'
              >
                <div class='d-flex justify-content-between align-items-center'>
                  <span class='job-time h-6 mb-2'>
                    <i class='far fa-briefcase me-2'></i>{' '}
                    <strong>Remote - Full Time</strong>
                  </span>
                  <span class='badge px-3 py-2 bg-custom-light rounded-pill small'>
                    Designer
                  </span>
                </div>
                <h3 class='h5'>UI/UX and Product Designer</h3>
                <ul class='job-info-list list-inline list-unstyled text-muted'>
                  <li class='list-inline-item'>
                    <span class='far fa-house-building me-1'></span> Figma
                  </li>
                  <li class='list-inline-item'>
                    <span class='far fa-map-marker-alt me-1'></span> San
                    Francissco
                  </li>
                  <li class='list-inline-item'>
                    <span class='far fa-wallet me-1'></span> $25k - $35k
                  </li>
                </ul>
                <div class='btn btn-outline-light btn-sm d-inline-block mt-4'>
                  Apply Now
                </div>
              </Link>
            </div>
            <div class='col-lg-6 col-md-12'>
              <Link
                to='/career-single'
                class='text-decoration-none mt-4 single-open-job p-5 bg-dark text-white d-block rounded-custom'
              >
                <div class='d-flex justify-content-between align-items-center'>
                  <span class='job-time h-6 mb-2'>
                    <i class='far fa-briefcase me-2'></i>{' '}
                    <strong>Full Time</strong>
                  </span>
                  <span class='badge px-3 py-2 bg-custom-light rounded-pill small'>
                    Manager
                  </span>
                </div>
                <h3 class='h5'>Senior Office Manager</h3>
                <ul class='job-info-list list-inline list-unstyled text-muted'>
                  <li class='list-inline-item'>
                    <span class='far fa-house-building me-1'></span> Dribble
                  </li>
                  <li class='list-inline-item'>
                    <span class='far fa-map-marker-alt me-1'></span> California
                  </li>
                  <li class='list-inline-item'>
                    <span class='far fa-wallet me-1'></span> $55k - $62k
                  </li>
                </ul>
                <div class='btn btn-outline-light btn-sm d-inline-block mt-4'>
                  Apply Now
                </div>
              </Link>
            </div>
            <div class='col-lg-6 col-md-12'>
              <Link
                to='/career-single'
                class='text-decoration-none mt-4 single-open-job p-5 bg-dark text-white d-block rounded-custom'
              >
                <div class='d-flex justify-content-between align-items-center'>
                  <span class='job-time h-6 mb-2'>
                    <i class='far fa-briefcase me-2'></i>{' '}
                    <strong>Remote</strong>
                  </span>
                  <span class='badge px-3 py-2 bg-custom-light rounded-pill small'>
                    Developer
                  </span>
                </div>
                <h3 class='h5'>Senior Backend Developer</h3>
                <ul class='job-info-list list-inline list-unstyled text-muted'>
                  <li class='list-inline-item'>
                    <span class='far fa-house-building me-1'></span> Slack
                  </li>
                  <li class='list-inline-item'>
                    <span class='far fa-map-marker-alt me-1'></span> United
                    State US
                  </li>
                  <li class='list-inline-item'>
                    <span class='far fa-wallet me-1'></span> $55k - $62k
                  </li>
                </ul>
                <div class='btn btn-outline-light btn-sm d-inline-block mt-4'>
                  Apply Now
                </div>
              </Link>
            </div> */}
          {/* </div> */} *
        </div>
      </section>
    </>
  );
};

export default OpenJobs;
